import { Countries, Products } from '@/comm'
import { useDatePicker } from '@/components/MyDatePicker'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { formatPercent, formatUSD } from '@/lib/format-utils'
import { getDateRange } from '@/lib/date-utils'

import { Button } from '@/components/ui/button'
import { createColumnVisibilityStore } from '@/components/zthd/data-table'
import { DataTableViewOptions } from '@/components/zthd/data-table-view-options'
import DataTableWithBorder from '@/components/zthd/data-table/data-table-with-border'
import {
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable,
} from '@tanstack/react-table'
import {
  useColumnFilters,
  VSWeekSelector,
} from '@/components/data-table-selectors'
import { useCountry } from '@/components/DropdownCountry'
import useSWR from 'swr'
import { columnDate } from './columns'
import { countryColumn } from '@/components/roi/country-daily/country-column'
const useColumnVisibilityStore = createColumnVisibilityStore({}, 'pcr')

const Home = () => {
  const startDate = useDatePicker((state) => state.startDate)
  const endDate = useDatePicker((state) => state.endDate)
  const country = useCountry((state) => state.value)

  const { columnVisibility, setColumnVisibility } = useColumnVisibilityStore()
  const columnFilters = useColumnFilters((state) => state.columnFilters)

  const { data: revenues, mutate } = useSWR([
    '/revenues/pc',
    { startDate, endDate, country },
  ])

  const data = useMemo(() => {
    const dateRange = getDateRange(dayjs(startDate), dayjs(endDate))
    return dateRange.map((date) => {
      const datas = revenues?.[date]

      return {
        date,
        datas: datas,
      }
    })
  }, [startDate, endDate, revenues])

  const columns = useMemo(() => {
    const rows = []
    rows.push(columnDate)
    Countries.forEach((c) => {
      rows.push(countryColumn(c.code, c.name))
    })
    return rows
  }, [])

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    enableMultiRowSelection: true,
    state: {
      columnFilters,
      columnVisibility,
    },
  })

  return (
    <>
      <div className="flex items-center xs:gap-1 xs:py-1 sm:gap-2 sm:py-2 gap-4 py-4   flex-wrap">
        <VSWeekSelector />
        <Button variant="outline" onClick={mutate}>
          refresh
        </Button>
        <DataTableViewOptions table={table} />
      </div>
      <DataTableWithBorder table={table} />
    </>
  )
}

export default Home
